import {
  SET_IS_LOADING,
  SET_IS_FIRST_SCHEDULING_ACCESS,
  SET_IS_CALENDAR_SELECTED,
  SET_IS_MAP_SELECTED,
  SET_DATE_CYCLE,
  SET_DATE_CYCLE_TEXT,
  SET_CALENDAR_OPTION,
  SET_CALENDAR_LIST,
  SET_MAP_LIST
} from './constants';

const defaultState = {
  isFirstSchedulingAccess: true,
  selectedCalendarOption: 'dayGridMonth',
  calendarOptions: [
    {
      label: 'Diário',
      value: 'timeGridDay'
    },
    {
      label: 'Semanal',
      value: 'timeGridWeek'
    },
    {
      label: 'Mensal',
      value: 'dayGridMonth'
    }
  ],
  calendarList: [],
  mapList: [],
  isCalendarSelected: true,
  isMapSelected: false,
  dateCycleCurrentState: '',
  dateCycleText: '',
  isLoading: false
}

const getTitle = item => {
  const { typeId, services, title } = item;

  if(+typeId == 1) {
    return services[0]?.serviceName || '';
  }

  if(+typeId == 2) {
    return title || '';
  }

  return '';
}

export default (state = defaultState, action) => {
  switch(action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action?.isLoading
      }
    }
    case SET_IS_FIRST_SCHEDULING_ACCESS: {
      return {
        ...state,
        isFirstSchedulingAccess: false
      }
    }
    case SET_IS_CALENDAR_SELECTED: {
      return {
        ...state,
        isCalendarSelected: action?.status
      }
    }
    case SET_IS_MAP_SELECTED: {
      return {
        ...state,
        isMapSelected: action?.status
      }
    }
    case SET_DATE_CYCLE: {
      return {
        ...state,
        dateCycleCurrentState: action?.dateType
      }
    }
    case SET_DATE_CYCLE_TEXT: {
      return {
        ...state,
        dateCycleText: action?.text
      }
    }
    case SET_CALENDAR_OPTION: {
      return {
        ...state,
        selectedCalendarOption: action?.option
      }
    }
    case SET_CALENDAR_LIST: {
      return {
        ...state,
        calendarList: action?.data?.map(item => {
          return {
            ...item,
            id: item?.id,
            title: getTitle(item),
            start: item?.startDateTime,
            end: item?.endDateTime,
            type: item?.typeId
          }
        })
      }
    }
    case SET_MAP_LIST: {
      return {
        ...state,
        mapList: action?.data?.map(item => {
          return {
            ...item,
            id: item?.id,
            title: getTitle(item),
            start: item?.startDateTime,
            end: item?.endDateTime,
            type: item?.typeId,
            latitude: !!item?.latitude ? +item?.latitude :  0,
            longitude: !!item?.longitude ? +item?.longitude : 0
          }
        })
      }
    }
    default: {
      return state;
    }
  }
}